import { i18n } from "../../utils/GadgetUtils";

export const READY_MENU_ID = 'ready-menu-item';
export const NOT_READY_MENU_ID = 'not-ready-menu-item';

export const CHAT_LABEL = i18n.getMsg('gadget.imi.fnc.label.chat');
export const EMAIL_LABEL = i18n.getMsg('gadget.imi.fnc.label.email');

export const CHAT_ICON_NAME = 'mui-chat-active_16';
export const EMAIL_ICON_NAME = 'mui-email-active_16';

const I18n = window.top.finesse.utilities.I18n;
const CHANNEL_SERVICE = window.finesse.digital.ChannelService;
export const AGENT_NON_VOICE_STATES = window.finesse.restservices.Media.States;

export const LABEL = {
    READY: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.READY),
    NOT_READY: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.NOT_READY)
};

export const CHANNEL_STATE_MAP = (() => {
	const stateOptionMap = new Map();

	stateOptionMap.set(AGENT_NON_VOICE_STATES.READY, {
		menuId: READY_MENU_ID,
        label: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.READY),
        status: CHANNEL_SERVICE.STATE_STATUS.AVAILABLE
    });

	stateOptionMap.set(AGENT_NON_VOICE_STATES.NOT_READY, {
		menuId: NOT_READY_MENU_ID,
        label: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.NOT_READY),
        status: CHANNEL_SERVICE.STATE_STATUS.UNAVAILABLE
	});

    stateOptionMap.set(AGENT_NON_VOICE_STATES.LOGOUT, {
		menuId: NOT_READY_MENU_ID,
        label: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.LOGOUT),
        status: CHANNEL_SERVICE.STATE_STATUS.UNAVAILABLE
	});

    stateOptionMap.set(AGENT_NON_VOICE_STATES.RESERVED, {
		menuId: READY_MENU_ID,
        label: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.READY),
        status: CHANNEL_SERVICE.STATE_STATUS.AVAILABLE
    });

    stateOptionMap.set(AGENT_NON_VOICE_STATES.WORK, {
		menuId: READY_MENU_ID,
        label: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.READY),
        status: CHANNEL_SERVICE.STATE_STATUS.AVAILABLE
    });

    stateOptionMap.set(AGENT_NON_VOICE_STATES.INTERRUPTED, {
		menuId: READY_MENU_ID,
        label: I18n.getString('desktop.agent.header.state.' + AGENT_NON_VOICE_STATES.READY),
        status: CHANNEL_SERVICE.STATE_STATUS.AVAILABLE
    });
	
	return stateOptionMap;
}
)();

export const AVAILABLE_MEDIA_TYPES = {
    email: ["email"],
    chat: ["chat", "sms", "facebook", "whatsapp"],
    unknown: ["Unknown"]
};

export const SUPPORTED_MEDIA_CHANNELS = {
    EMAIL: ["email"],
    CHAT: ["chat"],
    SOCIAL: ["sms", "facebook", "whatsapp"],
    UNKNOWN: ["unknown"]
};

export const AVAILABLE_MEDIA_CLASS = {
    EMAIL: "email",
    CHAT: "chat",
    SOCIAL: "social"
};